import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { LinkedIn, GitHub, Email, Download } from '@mui/icons-material';

const Contact = () => {
  return (
    <Box sx={{ py: 8, display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ maxWidth: 800, width: '100%', textAlign: 'center' }}>
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 700 }}>Contact</Typography>
        <Typography sx={{ mb: 3, color: 'text.secondary' }}>Available for full-time or contract front-end roles. Resume and links below.</Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3 }}>
          <Button href="mailto:shaileshkyadav24@gmail.com" startIcon={<Email />} variant="outlined">Email</Button>
          <Button href="./Shailesh_Yadav_Resume.md" startIcon={<Download />} variant="contained" color="primary" download>Resume</Button>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <IconButton href="https://linkedin.com/in/shaileshkyadav24" target="_blank"><LinkedIn /></IconButton>
          <IconButton href="https://github.com/shaileshyadav24" target="_blank"><GitHub /></IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default Contact;